import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from '../../components/panel/panel.jsx';
import { toast } from 'react-toastify';
import axios from 'axios'
import Select from 'react-select';
import Pagination from '../../components/pagination/pagination.jsx';
import Modal from 'react-modal';
import moment from 'moment/moment.js';
import ProvinceForm from './subdistrict.jsx';

import ModalWithProceed from '../../components/prompt/ModalWithProceed.jsx';
import { isEmpty } from "../../helper/helper.js"

function SubDistrictList({ props = {} }) {

  const [dataTable, setDataTable] = useState([])
  const [state, setState] = useState({});
  const [formData, setFormData] = useState({ mProvince: [], mCity: [], mDistrict: [], currentPage: 1, rowsPerPage: 50 });
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [modalUid, setModalUid] = useState('')

  const [promptDeleteIsOpen, setPromptDeleteIsOpen] = useState(false);

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target

    setState(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const onChangePageHandler = async (page) => {
    setFormData(prevState => ({ ...prevState, currentPage: page }))
    await refreshTable(page)
  }

  const onChangePageSelectHandler = async (e) => {
    setFormData(prevState => ({ ...prevState, rowsPerPage: e.target.value }))
    await refreshTable(state.currentPage, e.target.value)
  }

  const handleOnChangeProvince = async (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        province: option.value,
        city: null,
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/city`, { params: { prov_code: option.value } })
        .then(res => {
          const resp = res.data;
          setFormData(prevState => ({
            ...prevState,
            mCity: resp.data.city
          }))

        }).catch(err => {

        })

    } else {
      setState(prevState => ({
        ...prevState,
        province: '',
        city: '',
        district: ''
      }))

      setFormData(prevState => ({
            ...prevState,
            mCity: [],
            mDistrict: [],
          }))
    }
  }

  const handleOnChangeCity = async (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        city: option.value,
        district: null,
      }))

      await axios.get(`${window.API_HOST}/ui/v1/form/district`, { params: { city_code: option.value } })
        .then(res => {
          const resp = res.data;
          setFormData(prevState => ({
            ...prevState,
            mDistrict: resp.data.district ?? []
          }))

        }).catch(err => {

        })

    } else {

      setState(prevState => ({
        ...prevState,
        city: '',
        district: '',
      }))

      setFormData(prevState => ({
        ...prevState,
        mDistrict: []
      }))
    }
  }

  const handleOnChangeSelect = (option, e) => {
    if (e.action === "select-option") {
      setState(prevState => ({
        ...prevState,
        [e.name]: option.value,
      }))
    } else {
      setState(prevState => ({
        ...prevState,
        [e.name]: '',
      }))
    }
  }

  const openCityForm = async (uid, e) => {
    e.preventDefault();
    setModalUid(uid)
    setFormIsOpen(true)
  }

  const confirmDeleteSubdistrict = async () => {
    setPromptDeleteIsOpen(false)

    if (isEmpty(formData.id)) {
      return
    }

    await axios.delete(`${window.API_HOST}/v1/subdistrict/${formData.id}`)
      .then(res => {
        const data = res.data;

        toast.success(`Success delete district ${formData.name}`)
        refreshTable()

      }).catch(err => {
        toast.error(err.response?.data?.error ?? `Can't delete ${formData.name}`)
      })
  }

  const refreshTable = async (_page, _size) => {

    let params = {
      page: _page ?? formData.currentPage,
      size: _size ?? formData.rowsPerPage,
      province: state.province ?? '',
      city: state.city ?? '',
      district: state.district ?? '',
      subdistrict: state.subdistrict ?? '',
      postalcode: state.postalcode ?? '',
    }

    for (var key in params) {
      if (isEmpty(params[key])) {
        delete params[key]
      }
    }
    
    await axios.get(`${window.API_HOST}/v1/subdistrict`, { params })
      .then(res => {
        setDataTable(res.data?.data ?? [])
        setFormData(prevState => ({
          ...prevState,
          totalRows: res.data.meta.total
        }))

      }).catch(err => {

      })
  }

  const searchForm = async () => {
    setFormData(prevState => ({
      ...prevState,
      currentPage: 1
    }))
    refreshTable(1)

  }


  const fetchForm = async () => {
    await axios.get(`${window.API_HOST}/v1/city/form`)
      .then(res => {
        const data = res.data;
        setFormData(prevState => ({
          ...prevState,
          mProvince: data.data.province
        }))

      }).catch(err => {

      })
  }

  useEffect(() => {
    searchForm()
    fetchForm()
  }, []) //eslint-disable-next-line 


  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><Link to="/home"><i className='fa fa-home'></i> Home</Link></li>
      </ol>
      <h1 className="page-header">Sub District Postal Code<small></small></h1>
      <Panel>
        <PanelHeader noButton>Sub District List</PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-6'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Province</label>
                <div className="col-sm-9">
                  <Select name="province" placeholder={"Province"}
                    value={formData.mProvince.find(({ value }) => { return value === state.province }) ?? ""}
                    options={formData.mProvince}
                    onChange={handleOnChangeProvince}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
            </div>
            <div className='col-sm-6'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">City</label>
                <div className="col-sm-9">
                  <Select name="city" placeholder={"City"}
                    value={formData.mCity.find(({ value }) => { return value === state.city }) ?? ""}
                    options={formData.mCity}
                    onChange={handleOnChangeCity}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
            </div>
            <div className='col-sm-6'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">District</label>
                <div className="col-sm-9">
                  <Select name="district" placeholder={'District'}
                    value={formData.mDistrict.find(({ value }) => { return value === state.district }) ?? ""}
                    options={formData.mDistrict}
                    onChange={handleOnChangeSelect}
                    isClearable={true} isSearchable={true} />
                </div>
              </div>
            </div>
          </div>


          <div className='row'>
            <div className='col-sm-6'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Sub District / Postal Code</label>
                <div className="col-sm-9">
                  <div className='row'>
                    <div className='col-sm-6'>
                      <input type="text" name="subdistrict" value={state.subdistrict ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" placeholder='Sub District' />
                    </div>
                    <div className='col-sm-6'>
                      <input type="text" name="postalcode" value={state.postalcode ?? ""} onChange={handleOnChangeInputText} className="form-control form-control-sm" placeholder='Postal Code' />
                    </div>
                  </div> 

                </div>
              </div>
              <div className="form-group row my-2">
                <label className="col-sm-3 col-form-label">&nbsp;</label>
                <div className="col-sm-8">
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={searchForm}><span className="fa fa-sm fa-search"></span> Search</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => { }}><span className="fa fa-sm fa-download"></span> Download</button>
                  <button type="button" className="btn btn-sm btn-primary me-2" onClick={(e) => { openCityForm(null, e) }}><span className="fa fa-plus-circle fa-sm"></span> New</button>
                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
      <Panel>
        <PanelBody>
          <div className="table table-hover mb-0 text-dark">
            <table className="table table-sm table-hover table-striped mb-0 text-dark">
              <thead className='bg-lime-400 fw-bold'>
                <tr>
                  <th>No.</th>
                  <th className='w-90px'>Code</th>
                  <th>Name</th>
                  <th>Alias</th>
                  <th>Postal Code</th>
                  <th>Province</th>
                  <th>City</th>
                  <th>District</th>
                  <th>Active</th>
                  <th>Last Update</th>
                  <th>Updated By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(dataTable).map((val, key) => {
                  return (
                    <tr className='fs-8 fw-light' key={key}>
                      <td>{((formData.currentPage - 1) * formData.rowsPerPage) + (key + 1)}.</td>
                      <td>{val.subdistrict_code}</td>
                      <td>{val.subdistrict_name}</td>
                      <td>{val.other_name}</td>
                      <td>{val.postalcode}</td>
                      <td>{val.province_name}</td>
                      <td>{val.city_name}</td>
                      <td>{val.district_name}</td>
                      <td>{val.active ? 'Yes' : 'No'}</td>
                      <td>{moment(val.updated_at).format('YYYY-MM-DD HH-mm:ss')}</td>
                      <td>{val.updated_by}</td>
                      <td><button className='btn btn-xs me-3' onClick={(e) => { openCityForm(val.id, e) }}><i className='fa fa-pen-to-square'></i></button> <button className='btn btn-xs'><i className='fa fa-trash text-danger' onClick={() => {
                        setFormData(prevState => ({
                          ...prevState,
                          name: val.district_name,
                          id: val.id
                        }))
                        setPromptDeleteIsOpen(true);
                      }}></i></button></td>
                    </tr>)
                })}
              </tbody>
            </table>
          </div>
        </PanelBody>
        <PanelFooter>
          <div className='row'>
            <div className="col-sm-12">
              <Pagination
                currentPage={formData.currentPage ?? 1}
                totalRows={formData.totalRows ?? 1}
                pageSize={formData.rowsPerPage ?? 50}
                onPageChange={onChangePageHandler}
                selectedPageHandler={onChangePageSelectHandler}
              />
            </div>
          </div>
        </PanelFooter>
      </Panel>
      <>
        <Modal
          isOpen={formIsOpen}
          onAfterOpen={() => { }}
          onRequestClose={() => setFormIsOpen(false)}
          style={customStyles}
          ariaHideApp={false}  >
          <ProvinceForm props={{
            uid: modalUid, cancelAction: () => {
              setFormIsOpen(false)
            }
          }} />
        </Modal>


        <ModalWithProceed header={false} show={promptDeleteIsOpen} close={() => { setPromptDeleteIsOpen(false) }} proceed={confirmDeleteSubdistrict}>
          Do you want to delete <strong>{formData.name}</strong> ?
        </ModalWithProceed>

      </>
    </div>
  )
}

export default SubDistrictList;